"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enterFullScreen = void 0;

var _helpers = require("../../util/helpers");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * will make a given video enter full screen mode
 *
 * @param {string} containerId - HTML Node id of video container
 * @param {function} setIsFullScreen - call back method will call with true parameter when full screen mode is entered
 */
var enterFullScreen = function enterFullScreen(selector, setIsFullScreen) {
  var query = "".concat(selector);
  var useParent = true;

  if ((0, _helpers.isMobile)()) {
    query += ' video.main-video[data-active="true"]';
    useParent = false;
  }

  var elem = document.querySelector(query);

  if (useParent) {
    elem = elem.parentElement;
  }

  console.log("enterFullScreen", query, elem);

  try {
    var _elem, _elem2, _elem3, _elem4;

    if ((_elem = elem) !== null && _elem !== void 0 && _elem.webkitRequestFullscreen) {
      console.log("enterFullScreen", "webkitRequestFullscreen");
      elem.webkitRequestFullscreen();

      if (typeof setIsFullScreen === "function") {
        setIsFullScreen(true);
      }

      document.dispatchEvent(new Event("trc-fullscreen-enter"));
    } else if ((_elem2 = elem) !== null && _elem2 !== void 0 && _elem2.webkitEnterFullscreen) {
      console.log("enterFullScreen", "webkitEnterFullscreen");
      elem.webkitEnterFullscreen();

      if (typeof setIsFullScreen === "function") {
        setIsFullScreen(true);
      }

      document.dispatchEvent(new Event("trc-fullscreen-enter"));
    } else if ((_elem3 = elem) !== null && _elem3 !== void 0 && _elem3.requestFullscreen) {
      console.log("enterFullScreen", "requestFullscreen");
      elem.requestFullscreen();
      document.dispatchEvent(new Event("trc-fullscreen-enter"));

      if (typeof setIsFullScreen === "function") {
        setIsFullScreen(true);
      }
    } else if ((_elem4 = elem) !== null && _elem4 !== void 0 && _elem4.msRequestFullscreen) {
      console.log("enterFullScreen", "msRequestFullscreen");
      elem.msRequestFullscreen();

      if (typeof setIsFullScreen === "function") {
        setIsFullScreen(true);
      }

      document.dispatchEvent(new Event("trc-fullscreen-enter"));
    } else {
      console.log("enterFullScreen", "no fullscreen support");
    }
  } catch (e) {
    console.error("enterFullScreen", "error", e);
  }
};

exports.enterFullScreen = enterFullScreen;